import * as List from "bs-platform/lib/es6/list.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as ListLabels from "bs-platform/lib/es6/listLabels.js";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as Caml_builtin_exceptions from "bs-platform/lib/es6/caml_builtin_exceptions.js";

function filter_map(l, f) {
  return List.rev(List.fold_left(function (accum, x) {
    var match = Curry._1(f, x);

    if (match !== undefined) {
      return (
        /* :: */
        [Caml_option.valFromOption(match), accum]
      );
    } else {
      return accum;
    }
  },
  /* [] */
  0, l));
}

function assoc_opt(x, l) {
  try {
    return Caml_option.some(ListLabels.assoc(x, l));
  } catch (exn) {
    if (exn === Caml_builtin_exceptions.not_found) {
      return;
    } else {
      throw exn;
    }
  }
}

function $$return(x) {
  return (
    /* :: */
    [x,
    /* [] */
    0]
  );
}

function find_opt(l, f) {
  var _param = l;

  while (true) {
    var param = _param;

    if (param) {
      var match = Curry._1(f, param[0]);

      if (match !== undefined) {
        return Caml_option.some(Caml_option.valFromOption(match));
      } else {
        _param = param[1];
        continue;
      }
    } else {
      return;
    }
  }

  ;
}

var length = ListLabels.length;
var hd = ListLabels.hd;
var compare_lengths = ListLabels.compare_lengths;
var compare_length_with = ListLabels.compare_length_with;
var cons = ListLabels.cons;
var tl = ListLabels.tl;
var nth = ListLabels.nth;
var nth_opt = ListLabels.nth_opt;
var rev = ListLabels.rev;
var init = ListLabels.init;
var append = ListLabels.append;
var rev_append = ListLabels.rev_append;
var concat = ListLabels.concat;
var flatten = ListLabels.flatten;
var iter = ListLabels.iter;
var iteri = ListLabels.iteri;
var map = ListLabels.map;
var mapi = ListLabels.mapi;
var rev_map = ListLabels.rev_map;
var fold_left = ListLabels.fold_left;
var fold_right = ListLabels.fold_right;
var iter2 = ListLabels.iter2;
var map2 = ListLabels.map2;
var rev_map2 = ListLabels.rev_map2;
var fold_left2 = ListLabels.fold_left2;
var fold_right2 = ListLabels.fold_right2;
var for_all = ListLabels.for_all;
var exists = ListLabels.exists;
var for_all2 = ListLabels.for_all2;
var exists2 = ListLabels.exists2;
var mem = ListLabels.mem;
var memq = ListLabels.memq;
var find = ListLabels.find;
var filter = ListLabels.filter;
var find_all = ListLabels.find_all;
var partition = ListLabels.partition;
var assoc = ListLabels.assoc;
var assq = ListLabels.assq;
var assq_opt = ListLabels.assq_opt;
var mem_assoc = ListLabels.mem_assoc;
var mem_assq = ListLabels.mem_assq;
var remove_assoc = ListLabels.remove_assoc;
var remove_assq = ListLabels.remove_assq;
var split = ListLabels.split;
var combine = ListLabels.combine;
var sort = ListLabels.sort;
var stable_sort = ListLabels.stable_sort;
var fast_sort = ListLabels.fast_sort;
var sort_uniq = ListLabels.sort_uniq;
var merge = ListLabels.merge;
export { length, hd, compare_lengths, compare_length_with, cons, tl, nth, nth_opt, rev, init, append, rev_append, concat, flatten, iter, iteri, map, mapi, rev_map, fold_left, fold_right, iter2, map2, rev_map2, fold_left2, fold_right2, for_all, exists, for_all2, exists2, mem, memq, find, filter, find_all, partition, assoc, assq, assq_opt, mem_assoc, mem_assq, remove_assoc, remove_assq, split, combine, sort, stable_sort, fast_sort, sort_uniq, merge, filter_map, assoc_opt, $$return, find_opt };
/* No side effect */